/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {

	export class MeevoReferenceField implements angular.IDirective {

		restrict = "E";
		require = "ngModel";
		scope = {
			ngModel: "=",
			referenceType: "@",
			contentKey: "@",
			disabled: "=ngDisabled",
			required: "=ngRequired",
			change: "&ngChange",
			addEmptyElement: "=",
			emptyElementName: "@?",
			exclusionList: "=",
			tabIndex: "=tabIndex",
			tooltip: "@",
			displayNameBinding: "=?"
		}

		template = `<div>
                      <div class=\"meevo_input_wrapper\" ng-show="::(required || contentKey)">
                        <label translate="{{::contentKey}}"></label>
                        <div ng-class=\"{\'ng-dirty required_red_bubble \' : required}\"></div>
                      </div>
                      <md-select ng-model="ngModel" tabindex=\"{{tabIndex || 0}}\" 
                                 id=\"{{contentKey + ngModel +  $parent.$index }}\"
                                 ng-required="required"
                                 md-no-asterisk 
                                 ng-disabled="disabled" 
                                 placeholder=\"{{selectedDisplayName}}\"
                                 ng-class="{'red_border_invalid' : required && !ngModel, 'disabled': disabled}"
                                 md-on-close="change()">
                        <md-option ng-value="rd.id"
                                   ng-repeat="rd in referenceData">
                          {{ rd.displayName }}
                        </md-option>
                        <md-tooltip md-direction="top" ng-if="tooltip">
                            <span>{{::tooltip}}</span>
                        </md-tooltip>
                      </md-select>
                    </div>`;


		link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes): void => {
			let str: string = scope.referenceType;
			let refEnumType: Model.EnumTypeEnum = Model.EnumTypeEnum[str];

			if (refEnumType === undefined) {
				alert(`Invalid reference-type '${str}' specified in meevo-reference-field.\n\nPlease specify a valid value contained within Model.EnumTypeEnum`);
				return;
			}

			scope.originalData = [];
			scope.selectedDisplayName = null;

			this.dataService.getEnumList(refEnumType)
				.then((data: any) => {

					scope.originalData = angular.copy(data);

					if (scope.exclusionList) {
						for (var i = 0; i < scope.exclusionList.length; i++) {
							data = _.without(data, _.findWhere(data, { id: scope.exclusionList[i] }));
						}
					}

					scope.referenceData = data;

					if (scope.addEmptyElement) {
						var emptyFound = _.find(data, (obj: any) => { return obj.id === 0; });
						if (!emptyFound) {
							scope.referenceData.unshift({
								id: (scope.emptyElementName != "") ? "" : 0,
								value: (scope.emptyElementName != "") ? scope.emptyElementName : "",
								displayName: (scope.emptyElementName != "") ? this.$translate.instant(scope.emptyElementName) : ""
							});
						}
					}
					else {
						if (!scope.referenceData || !scope.referenceData[0]) {
							console.warn('ReferenceField: No Enum Value Available For ', scope.referenceType);
						}
						else {
							scope.displayNameBinding = scope.referenceData[0].displayName;
						}
					}

					let temp: any = _.findWhere(scope.referenceData, { id: parseInt(scope.ngModel) });
					scope.displayNameBinding = temp ? temp.displayName : undefined;
					if (!temp) {
						temp = _.findWhere(scope.originalData, { id: parseInt(scope.ngModel) });
					}
					scope.selectedDisplayName = temp ? temp.displayName : "";
				});

			scope.$watch('ngModel', function (newVal) {
				if (scope.referenceData) {
					let temp: any = _.findWhere(scope.referenceData, { id: parseInt(newVal) });
					scope.displayNameBinding = temp ? temp.displayName : undefined;
					if (!temp) {
						temp = _.findWhere(scope.originalData, { id: parseInt(newVal) });
					}
					scope.selectedDisplayName = temp ? temp.displayName : "";
				}
				if (Model.Guard.isSomething(scope.exclusionList) && scope.exclusionList.length > 0) {
					for (var i = 0; i < scope.exclusionList.length; i++) {
						scope.referenceData = _.without(scope.referenceData, _.findWhere(scope.referenceData, { id: scope.exclusionList[i] }));
					}
				}
			});
		}

		constructor(private dataService: Meevo.Components.BaseClasses.IDataService,
			private $translate) {

		}

		static factory(): angular.IDirectiveFactory {
			let directive = (dataService: Meevo.Components.BaseClasses.IDataService,$translate) => {
				return new MeevoReferenceField(dataService,$translate);
			};

			directive.$inject = ["meevo.components.common.DataService", "$translate"];
			return directive;
		}
	}

	angular.module("meevo.components.controls")
		.directive("meevoReferenceField", MeevoReferenceField.factory());
}